import {HiOutlineMail} from 'react-icons/hi'
import {RiMessengerLine} from 'react-icons/ri'
import React from 'react'

const data = [
    {id: 1, icon: <HiOutlineMail/>, link: 'mailto:dominicdigiacomo16@gmail.com'},
    {id: 2, icon: <RiMessengerLine/>, link: 'https://www.facebook.com/messages/t/100014270524012'},
]


export default data